import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable, Subject, takeUntil, tap } from 'rxjs';

// SERVICES
import { OptionInterface } from 'v2/modules/shared/interfaces/common.interface';
import { UserGroupsApiService } from 'v2/modules/shared/services/api/user-groups-api.service';

// INTERFACE
import { IUserGroup } from 'v2/modules/user-groups/interfaces/user-groups.interface';

@Component({
  selector: 'lum-filter-user-groups',
  templateUrl: './filter-user-groups.component.html',
  styleUrls: ['./filter-user-groups.component.scss'],
})
export class FilterUserGroupsComponent implements OnInit {
  @Input()
  queryId :string = 'userGroup';

  @Input()
  value :number[] = [];

  @Input()
  label :string = 'User Groups';

  @Input()
  placeholder :string = 'User Group';

  @Input()
  multiple :boolean = false;

  @Output()
  onFilterSelect :EventEmitter<any[] | any> = new EventEmitter<any>();

  items :OptionInterface[];
  items$ :Observable<OptionInterface[]>;
  private onDestroy$ = new Subject();

  constructor(private userGroupApiService :UserGroupsApiService) {}

  ngOnInit() :void {
    this.userGroupApiService
      .get({ all: 'true' })
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((resp :any) => {
        if (resp?.data) {
          this.items = resp.data.map((userGroup :IUserGroup) => ({
            ...userGroup,
            value: {
              id: userGroup.id,
              label: userGroup.label,
            },
            options: {
              currentValue: [
                {
                  id: userGroup.id,
                  label: userGroup.label,
                },
              ],
            },
            label: `${userGroup.label}`,
          }));
        }
      });
  }

  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  onSelectedChangeEvent(userGroups :any) :void {
    this.onFilterSelect.emit({
      [this.queryId]: userGroups,
    });
  }
}
